export default "__VITE_ASSET__4ac934f2__"